// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Concentrators_container__hnXFt {
  animation: Concentrators_init__D2YId 0.5s;
  width: 100%;
  display: flex;
  font-size: 16px;
  align-items: center;
  flex-direction: column;
}

.Concentrators_container__hnXFt .Concentrators_header__o34qO {
  width: 90%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
}

.Concentrators_container__hnXFt .Concentrators_header__o34qO .Concentrators_titleConcentrators__gNikP {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.Concentrators_container__hnXFt .Concentrators_header__o34qO .Concentrators_titleConcentrators__gNikP .Concentrators_title__PNcgv {
  font-size: 1.8rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
  margin: 0 0 0 10px;
}

.Concentrators_container__hnXFt .Concentrators_header__o34qO .Concentrators_filters__j4WAn {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.Concentrators_container__hnXFt .Concentrators_header__o34qO .Concentrators_filters__j4WAn .Concentrators_filterButton__qT1fk {
  text-transform: capitalize;
  height: 3rem;
  width: 10rem;
  margin-top: 10px;
  margin-left: 5px;
  border-radius: 5px;
}

.Concentrators_container__hnXFt .Concentrators_tableContainer__IEh1b {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 90%;
  min-height: 400px;
}

.Concentrators_container__hnXFt .Concentrators_noResults__OHOlJ {
  font-size: 32px;
  font-weight: 300;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.Concentrators_container__hnXFt .Concentrators_tableContainer__IEh1b .Concentrators_table__VHSJa {
  width: 100%;
  max-height: 70vh;
  border-radius: 10px;
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);
}

.Concentrators_pagination__xLuvs {
  scale: 1.3;
  margin-top: 40px;
  margin-bottom: 10px;
}

.Concentrators_insertPaginate__kX4NT {
  width: 30px;
  height: 30px;
}

.Concentrators_insertPaginateButton__3lTkk {
  width: 30px;
  height: 30px;
}

@keyframes Concentrators_init__D2YId {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@media screen and (max-width: 500px) {
  .Concentrators_container__hnXFt .Concentrators_header__o34qO .Concentrators_titleConcentrators__gNikP .Concentrators_title__PNcgv {
    font-size: 28px;
    margin-left: 0;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .Concentrators_container__hnXFt .Concentrators_header__o34qO .Concentrators_filters__j4WAn .Concentrators_filterButton__qT1fk {
    width: 100%;
    margin-bottom: 20px;
  }
}

@media screen and (max-width: 900px) {
  .Concentrators_container__hnXFt .Concentrators_header__o34qO .Concentrators_filters__j4WAn {
    justify-content: flex-start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/Concentrators/Concentrators.module.css"],"names":[],"mappings":"AAAA;EACE,yCAAoB;EACpB,WAAW;EACX,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF","sourcesContent":[".container {\n  animation: init 0.5s;\n  width: 100%;\n  display: flex;\n  font-size: 16px;\n  align-items: center;\n  flex-direction: column;\n}\n\n.container .header {\n  width: 90%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n\n.container .header .titleConcentrators {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .header .titleConcentrators .title {\n  font-size: 1.8rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n  margin: 0 0 0 10px;\n}\n\n.container .header .filters {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.container .header .filters .filterButton {\n  text-transform: capitalize;\n  height: 3rem;\n  width: 10rem;\n  margin-top: 10px;\n  margin-left: 5px;\n  border-radius: 5px;\n}\n\n.container .tableContainer {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  width: 90%;\n  min-height: 400px;\n}\n\n.container .noResults {\n  font-size: 32px;\n  font-weight: 300;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .tableContainer .table {\n  width: 100%;\n  max-height: 70vh;\n  border-radius: 10px;\n  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);\n}\n\n.pagination {\n  scale: 1.3;\n  margin-top: 40px;\n  margin-bottom: 10px;\n}\n\n.insertPaginate {\n  width: 30px;\n  height: 30px;\n}\n\n.insertPaginateButton {\n  width: 30px;\n  height: 30px;\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@media screen and (max-width: 500px) {\n  .container .header .titleConcentrators .title {\n    font-size: 28px;\n    margin-left: 0;\n    margin-top: 20px;\n    margin-bottom: 20px;\n  }\n\n  .container .header .filters .filterButton {\n    width: 100%;\n    margin-bottom: 20px;\n  }\n}\n\n@media screen and (max-width: 900px) {\n  .container .header .filters {\n    justify-content: flex-start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Concentrators_container__hnXFt`,
	"init": `Concentrators_init__D2YId`,
	"header": `Concentrators_header__o34qO`,
	"titleConcentrators": `Concentrators_titleConcentrators__gNikP`,
	"title": `Concentrators_title__PNcgv`,
	"filters": `Concentrators_filters__j4WAn`,
	"filterButton": `Concentrators_filterButton__qT1fk`,
	"tableContainer": `Concentrators_tableContainer__IEh1b`,
	"noResults": `Concentrators_noResults__OHOlJ`,
	"table": `Concentrators_table__VHSJa`,
	"pagination": `Concentrators_pagination__xLuvs`,
	"insertPaginate": `Concentrators_insertPaginate__kX4NT`,
	"insertPaginateButton": `Concentrators_insertPaginateButton__3lTkk`
};
export default ___CSS_LOADER_EXPORT___;
